import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { DrawerBoxComponent } from '../DrawerBoxComponent/DrawerBoxComponent';
import StatusIcon from '@mui/icons-material/FiberManualRecord';
import { APPOINTMENTS } from '../../shared/Strings';

export const AppointmentPaymentDetails = ({ amount, status, paymentID }) => {
  return (
    <DrawerBoxComponent>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <Typography variant="navSelected">
            {APPOINTMENTS.PAYMENT_DETAILS}
          </Typography>
        </Grid>
        <Grid item>
          <Grid container spacing={1} direction="column">
            <Grid item>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5">
                  {APPOINTMENTS.AMOUNT} : {amount}
                </Typography>
                <StatusIcon
                  htmlColor="green"
                  sx={{
                    height: 12,
                    width: 12,
                    mr: 0.5,
                    ml: 1,
                  }}
                />
                <Typography variant="h5">{status}</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Typography variant="h5">
                {APPOINTMENTS.PAYMENT_ID} : {paymentID}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DrawerBoxComponent>
  );
};
